import { render, staticRenderFns } from "./MultiColorSelect.vue?vue&type=template&id=7a22615f"
import script from "./MultiColorSelect.vue?vue&type=script&lang=js"
export * from "./MultiColorSelect.vue?vue&type=script&lang=js"
import style0 from "./MultiColorSelect.vue?vue&type=style&index=0&id=7a22615f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports